import React from "react";
import { Form } from "react-bootstrap";
import { useParams } from "react-router";
import Select, { createFilter } from "react-select";

import * as api from "../../api/api";

export default function AppSelector(props) {
    const { organizationId, locationId } = useParams();
    const [locationApps] = api.useLocationApps(organizationId, locationId);
    const [selectedOptions, setSelectedOptions] = React.useState(
        props.value
            ? locationApps.filter((app) => props.value.includes(app.id))
            : [],
    );
    const options = locationApps
        .map((app) => ({ value: app.id, label: app.name }))
        .filter(
            (app) =>
                !props.usedApps.some((searchApp) => searchApp.id === app.value),
        );

    const handleChange = (selected) => {
        setSelectedOptions(selected || []);
        props.onChange(selected ? selected.map((opt) => opt.value) : []);
    };

    return (
        <Form.Group controlId="appSelector">
            {!options.length && (
                <span className="text-danger">All Apps are used</span>
            )}
            <Select
                isMulti
                isDisabled={!options.length}
                options={options}
                value={selectedOptions}
                onChange={handleChange}
                placeholder="Select apps..."
                filterOption={createFilter({
                    stringify: (option) => option.label,
                })} // Only match labels when typing
                classNamePrefix="react-select"
                styles={{
                    menu: (base) => ({
                        ...base,
                        zIndex: 9999,
                    }),
                }}
            />
        </Form.Group>
    );
}
